import React from 'react';
import { 
  UserIcon, 
  ShoppingBagIcon, 
  ImageIcon, 
  ChartBarIcon, 
  CogIcon 
} from '../icons';

export type MobileTab = 'clients' | 'orders' | 'gallery' | 'dashboard' | 'profile' | 'about';

interface BottomNavProps {
  activeTab: MobileTab;
  onTabChange: (tab: MobileTab) => void;
  hasNotifications?: boolean;
}

export const BottomNav: React.FC<BottomNavProps> = ({ activeTab, onTabChange, hasNotifications }) => {
  const tabs = [
    { id: 'clients', label: 'Clients', icon: UserIcon },
    { id: 'orders', label: 'Commandes', icon: ShoppingBagIcon },
    { id: 'gallery', label: 'Galeries', icon: ImageIcon },
    { id: 'dashboard', label: 'Stats', icon: ChartBarIcon },
    { id: 'profile', label: 'Réglages', icon: CogIcon },
  ] as const;

  return (
    <nav className="fixed bottom-0 left-0 right-0 t-nav shadow-[0_-8px_30px_-10px_rgba(0,0,0,0.15)] px-4 py-2 pb-safe z-50 md:hidden">
      <div className="flex items-center justify-between max-w-lg mx-auto gap-1">
        {tabs.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            onClick={() => onTabChange(id)}
            className={`flex flex-col items-center justify-center flex-1 min-w-[64px] transition-all duration-300 relative group`}
          >
            {/* Pill Active State */}
            <div className={`
              p-2.5 rounded-2xl transition-all duration-500 flex flex-col items-center
              ${activeTab === id 
                ? 'bg-indigo-600/10 dark:bg-indigo-400/10 text-indigo-700 dark:text-indigo-400 shadow-sm' 
                : 'text-gray-500 dark:text-gray-400 hover:bg-gray-100/50 dark:hover:bg-white/5'}
            `}>
              <div className="relative">
                <Icon className={`
                  w-6 h-6 transition-all duration-500
                  ${activeTab === id ? 'scale-110' : 'group-hover:scale-105'}
                `} />
                {id === 'orders' && hasNotifications && (
                  <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-red-500 border-2 border-white rounded-full animate-pulse"></span>
                )}
              </div>
              <span className={`
                text-[10px] mt-1 font-semibold tracking-wide transition-all duration-300
                ${activeTab === id ? 'opacity-100' : 'opacity-80'}
              `}>
                {label}
              </span>
            </div>
            
            {/* Active Indicator Line */}
            {activeTab === id && (
              <span className="absolute -bottom-1 w-6 h-1 bg-indigo-600 dark:bg-indigo-400 rounded-full animate-in fade-in slide-in-from-bottom-1 duration-500"></span>
            )}
          </button>
        ))}
      </div>
    </nav>
  );
};
